var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.02 12.7729C24.02 11.922 23.9436 11.1038 23.8018 10.3184H12.5V14.9602H18.9582C18.68 16.4602 17.8345 17.7311 16.5636 18.582V21.5929H20.4418C22.7109 19.5038 24.02 16.4274 24.02 12.7729Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.501 24.4998C15.741 24.4998 18.4573 23.4252 20.4428 21.5925L16.5646 18.5816C15.4901 19.3016 14.1155 19.7271 12.501 19.7271C9.37553 19.7271 6.73007 17.6161 5.78643 14.7798H1.77734V17.8889C3.75189 21.8107 7.81007 24.4998 12.501 24.4998Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78545 14.7799C5.54545 14.0599 5.40909 13.2908 5.40909 12.4999C5.40909 11.709 5.54545 10.9399 5.78545 10.2199V7.11084H1.77636C0.963636 8.73084 0.5 10.5636 0.5 12.4999C0.5 14.4363 0.963636 16.269 1.77636 17.889L5.78545 14.7799Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.501 5.27273C14.2628 5.27273 15.8446 5.87818 17.0883 7.06727L20.5301 3.62545C18.4519 1.68909 15.7355 0.5 12.501 0.5C7.81007 0.5 3.75189 3.18909 1.77734 7.11091L5.78643 10.22C6.73007 7.38364 9.37553 5.27273 12.501 5.27273Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.f07c5187a3f9d7ef168a506e11a32f1d.svg";
export { ForwardRef as ReactComponent };